__turbopack_context__.v({
  "Heading": "styles-module__v2BRHW__Heading",
  "Heading--l": "styles-module__v2BRHW__Heading--l",
  "Heading--m": "styles-module__v2BRHW__Heading--m",
  "Heading--s": "styles-module__v2BRHW__Heading--s",
  "Heading--xl": "styles-module__v2BRHW__Heading--xl",
  "Heading--xs": "styles-module__v2BRHW__Heading--xs",
  "Heading--xxl": "styles-module__v2BRHW__Heading--xxl",
  "Heading--xxxl": "styles-module__v2BRHW__Heading--xxxl",
  "Heading--xxxxl": "styles-module__v2BRHW__Heading--xxxxl",
});
